import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import User from '@components/membership/models/User';
import { restaurantAdmin, superAdmin } from '@components/membership/const/userRole';
import ManageAccountsTwoToneIcon from '@mui/icons-material/ManageAccountsTwoTone';
import ShoppingBagTwoToneIcon from '@mui/icons-material/ShoppingBagTwoTone';
import DesktopWindowsTwoToneIcon from '@mui/icons-material/DesktopWindowsTwoTone';

interface NavigationMenuProps {
    onClick: (route: string) => void;
    user: User;
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ onClick, user }) => {
    const userRoleName = user.userRole?.name;
    return (
        <>
            {userRoleName !== undefined && (userRoleName === superAdmin || userRoleName === restaurantAdmin) &&
                <MenuItem onClick={() => onClick("/administration/")}>
                    <DesktopWindowsTwoToneIcon />
                    <Typography ml={2} textAlign="center">Administracija</Typography>
                </MenuItem>
            }
            <MenuItem onClick={() => onClick("/user-settings/")}>
                <ManageAccountsTwoToneIcon />
                <Typography ml={2} textAlign="center">Profil</Typography>
            </MenuItem>
            <MenuItem onClick={() => onClick(`/user-settings/${user?.id}/my-orders`)}>
                <ShoppingBagTwoToneIcon />
                <Typography ml={2} textAlign="center">Moje narudzbe</Typography>
            </MenuItem>
        </>
    )
}

export default NavigationMenu;